module.exports = __webpack_public_path__ + "static/media/got.d131c8e3.jpg";